import { Square, Workflow, Code2, Network, CalendarRange, Database, PieChart, Clock, Map, ArrowRightLeft, ClipboardList, LineChart, Activity, LayoutTemplate, Fish, Trello, FolderTree } from 'lucide-vue-next'
import { markRaw } from 'vue'

import DiagramEditorDialog from './DiagramEditorDialog.vue'
import FlowchartEditorDialog from './FlowchartEditorDialog.vue'
import ArchitectureEditorDialog from './ArchitectureEditorDialog.vue'
import GanttEditorDialog from './GanttEditorDialog.vue'
import EntityRelationshipEditorDialog from './EntityRelationshipEditorDialog.vue'
import PieEditorDialog from './PieEditorDialog.vue'
import TimelineEditorDialog from './TimelineEditorDialog.vue'
import JourneyEditorDialog from './JourneyEditorDialog.vue'
import SequenceEditorDialog from './SequenceEditorDialog.vue'
import RequirementEditorDialog from './RequirementEditorDialog.vue'
import XYChartEditorDialog from './XYChartEditorDialog.vue'
import StateEditorDialog from './StateEditorDialog.vue'
import EventModelingEditorDialog from './EventModelingEditorDialog.vue'
import IshikawaEditorDialog from './IshikawaEditorDialog.vue'
import KanbanEditorDialog from './KanbanEditorDialog.vue'
import TreeViewEditorDialog from './TreeViewEditorDialog.vue'
import MermaidLiveEditorDialog from './MermaidLiveEditorDialog.vue'

export const DIAGRAM_TYPES = [
  { 
    id: 'class', 
    label: 'Diagrama de Clases (UML)', 
    icon: markRaw(Square), 
    component: markRaw(DiagramEditorDialog) 
  },
  { 
    id: 'flow', 
    label: 'Diagrama de Flujo (Flowchart)', 
    icon: markRaw(Workflow), 
    component: markRaw(FlowchartEditorDialog) 
  },
  {
    id: 'architecture',
    label: 'Diagrama de Arquitectura (Cloud)',
    icon: markRaw(Network),
    component: markRaw(ArchitectureEditorDialog)
  },
  {
    id: 'gantt',
    label: 'Diagrama de Gantt (Cronograma)',
    icon: markRaw(CalendarRange),
    component: markRaw(GanttEditorDialog)
  },
  {
    id: 'er',
    label: 'Diagrama Entidad-Relación (ER)',
    icon: markRaw(Database),
    component: markRaw(EntityRelationshipEditorDialog)
  },
  {
    id: 'pie',
    label: 'Gráfico de Pastel (Pie Chart)',
    icon: markRaw(PieChart),
    component: markRaw(PieEditorDialog)
  },
  {
    id: 'timeline',
    label: 'Línea de Tiempo (Timeline)',
    icon: markRaw(Clock),
    component: markRaw(TimelineEditorDialog)
  },
  {
    id: 'journey',
    label: 'User Journey (Mapa de Viaje)',
    icon: markRaw(Map),
    component: markRaw(JourneyEditorDialog)
  },
  {
    id: 'sequence',
    label: 'Diagrama de Secuencia',
    icon: markRaw(ArrowRightLeft),
    component: markRaw(SequenceEditorDialog)
  },
  {
    id: 'requirement',
    label: 'Diagrama de Requisitos',
    icon: markRaw(ClipboardList),
    component: markRaw(RequirementEditorDialog)
  },
  {
    id: 'xychart',
    label: 'Gráfico XY (Barras y Líneas)',
    icon: markRaw(LineChart),
    component: markRaw(XYChartEditorDialog)
  },
  {
    id: 'state',
    label: 'Diagrama de Estados (State Diagram)',
    icon: markRaw(Activity),
    component: markRaw(StateEditorDialog)
  },
  {
    id: 'eventmodeling',
    label: 'Diagrama de Event Modeling',
    icon: markRaw(LayoutTemplate),
    component: markRaw(EventModelingEditorDialog)
  },
  {
    id: 'ishikawa',
    label: 'Diagrama Ishikawa (Espina de Pescado)',
    icon: markRaw(Fish),
    component: markRaw(IshikawaEditorDialog)
  },
  {
    id: 'kanban',
    label: 'Tablero Kanban',
    icon: markRaw(Trello),
    component: markRaw(KanbanEditorDialog)
  },
  {
    id: 'tree',
    label: 'Diagrama de Árbol (Tree View)',
    icon: markRaw(FolderTree),
    component: markRaw(TreeViewEditorDialog)
  },
  { 
    id: 'live', 
    label: 'Editor Avanzado Mermaid (Texto Puro)', 
    icon: markRaw(Code2), 
    component: markRaw(MermaidLiveEditorDialog) 
  },
]
